export const STORAGE_KEYS = {
  ACCESS_TOKEN: "accessToken",
  BACK_FROM_BOOKING: "uberdoc-back-from-booking",
  BACK_FROM_SPECIALIST_PROFILE: "uberdoc-back-from-specialist-profile",
  PENDING_BOOKING: "uberdoc-pending-booking",
  PENDING_BOOKING_SEARCH: "uberdoc-pending-booking-search",
  SEARCHED_ZIP_CODE: "uberdoc-searched-zip-code",
} as const;
